export default (phoneNumber) => {
    return `+61-${phoneNumber.replace(/[\(\)]/g,'').replace(/\s/g, '-')}`;
};
